<template>
  <div class="fileUpload">
    <button type="button" class="button--Error" v-if="item" @click="item = ''">
      <icon name="trash"></icon> {{ $store.getters.getStringTranslation('removeFile') }}
    </button>

    <button type="button" class="button" @click="toggleModal(true)" v-else>
      <icon name="cloud-upload"></icon> {{ label }}
    </button>

    <transition name="fade">
      <div class="modal--Uploads" v-if="visible">
        <button type="button" class="modal__Overlay" @click="toggleModal(false)">
          {{ $store.getters.getStringTranslation('close') }}
        </button>
        <uploads v-model="item" :selectable="true" :filterable="false" :defaults="{ types }" />
      </div>
    </transition>
  </div>
</template>

<script>
import Uploads from '@/components/Uploads.vue'

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Choose file',
    },
    types: {
      type: Array,
      default() {
        return ['pdf', 'doc', 'xls', 'ppt']
      },
    },
  },
  components: {
    Uploads,
  },
  data() {
    return {
      visible: false,
    }
  },
  computed: {
    item: {
      set(val) {
        this.$emit('input', val.url ? val.url : val)
        if (val !== null) this.visible = false
      },
      get() {
        return this.value
      },
    },
  },
  methods: {
    toggleModal(val) {
      if (val === true) {
        this.$store.dispatch('setWrapperClass', 'no-Overflow')
      } else {
        this.$store.dispatch('setWrapperClass', null)
      }

      this.visible = val
    },
    removeFile() {
      this.item = ''
    },
  },
}
</script>
